module.exports = __webpack_public_path__ + "img/3.1d2fb2d1.png";